import { Component, input } from '@angular/core';
import { environment } from 'projects/nr-b2b/src/environments/environment';

@Component({
	selector: 'nr-google-static-map',
	templateUrl: './google-static-map.component.html',
	styleUrls: ['./google-static-map.component.scss'],
	standalone: false,
})
export class GoogleStaticMapComponent {
	readonly lat = input.required<number>();
	readonly lng = input.required<number>();
	readonly zoom = input(15);
	readonly width = input(400);
	readonly height = input(200);
	readonly marker = input(true);

	private apiKey = environment.googleMapsApiKey;

	get mapUrl(): string {
		const base = 'https://maps.googleapis.com/maps/api/staticmap';
		const center = `center=${this.lat()},${this.lng()}`;
		const zoom = `zoom=${this.zoom()}`;
		const size = `size=${this.width()}x${this.height()}`;
		const marker = this.marker() ? `&markers=color:red%7C${this.lat()},${this.lng()}` : '';
		const key = `key=${this.apiKey}`;
		return `${base}?${center}&${zoom}&${size}${marker}&${key}`;
	}
}
